module.exports = __webpack_public_path__ + "img/insight_gif.77f20e5b.gif";